import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "legend" }
const _hoisted_2 = { class: "text-base bg-opacity-80 bg-blue-200 mt-3" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Legend ")
const _hoisted_4 = {
  key: 0,
  class: "m-1 table-auto text-xs bg-opacity-40 bg-white w-full text-left"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("div", {
      style: {"background-color":"#77aaff","border-width":"2px","border-color":"#444"},
      class: "w-4 h-4 rounded-full mx-auto"
    })
  ]),
  /*#__PURE__*/_createElementVNode("td", null, "Inspected Paper")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("div", {
      style: {"background-color":"#77aaff"},
      class: "w-4 h-4 rounded-full mx-auto"
    })
  ]),
  /*#__PURE__*/_createElementVNode("td", null, "Published Paper")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("div", {
      style: {"background-color":"#b31b1b"},
      class: "w-4 h-4 rounded-full mx-auto"
    })
  ]),
  /*#__PURE__*/_createElementVNode("td", null, "arXiv preprint")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("div", {
      style: {"background-color":"#238636"},
      class: "w-4 h-4 rounded-full mx-auto"
    })
  ]),
  /*#__PURE__*/_createElementVNode("td", null, "GitHub Repository")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("div", {
      style: {"background-color":"#999"},
      class: "w-4 h-4 rounded-full mx-auto"
    })
  ]),
  /*#__PURE__*/_createElementVNode("td", null, "Grey Literature")
], -1)
const _hoisted_10 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "float-right",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
      }, _toDisplayString(_ctx.open ? "🔼" : "🔽"), 1)
    ]),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("table", _hoisted_4, _hoisted_10))
      : _createCommentVNode("", true)
  ]))
}